import React from "react";

import {
    FaWallet,
    FaMoneyBillWave,
    FaExclamationTriangle,
    FaCheckCircle,
} from "react-icons/fa";

import SectionCard from "./SectionCard";
import MetricCard from "./MetricCard";

import {
    formatCurrency,
} from "../utils/dashboardFormatters";


const PaymentOverview = ({
    sales = {},
}) => {

    const totalSales =
        Number(
            sales?.totalSales ||
            0
        );


    const paidAmount =
        Number(
            sales?.paidAmount ||
            0
        );


    const outstandingAmount =
        Number(
            sales?.outstandingAmount ||
            0
        );


    const collectionPercentage =
        totalSales > 0
            ? Number(
                (
                    (
                        paidAmount /
                        totalSales
                    ) *
                    100
                ).toFixed(
                    1
                )
            )
            : 0;


    return (

        <SectionCard
            title="Payment Overview"
            subtitle="Collections and outstanding customer payments."
        >

            <div className="dashboard-sales-grid">

                <MetricCard
                    title="Collected"
                    value={
                        formatCurrency(
                            paidAmount
                        )
                    }
                    icon={FaCheckCircle}
                />


                <MetricCard
                    title="Outstanding"
                    value={
                        formatCurrency(
                            outstandingAmount
                        )
                    }
                    icon={FaExclamationTriangle}
                    emphasis
                />


                <MetricCard
                    title="Total Sales"
                    value={
                        formatCurrency(
                            totalSales
                        )
                    }
                    icon={FaMoneyBillWave}
                />


                <MetricCard
                    title="Collection Rate"
                    value={
                        `${collectionPercentage}%`
                    }
                    icon={FaWallet}
                />

            </div>


            <div className="dashboard-payment-progress">

                <div className="dashboard-payment-progress-header">

                    <span>
                        Collection Progress
                    </span>


                    <strong>
                        {collectionPercentage}%
                    </strong>

                </div>


                <div className="dashboard-payment-progress-track">

                    <div
                        className="dashboard-payment-progress-bar"

                        style={{
                            width:
                                `${Math.min(
                                    collectionPercentage,
                                    100
                                )}%`,
                        }}
                    />

                </div>

            </div>

        </SectionCard>

    );

};


export default PaymentOverview;